import { render, staticRenderFns } from "./_BodyContentInputPhone.vue?vue&type=template&id=20c0b6b8&scoped=true"
import script from "./_BodyContentInputPhone.vue?vue&type=script&lang=js"
export * from "./_BodyContentInputPhone.vue?vue&type=script&lang=js"
import style0 from "./_BodyContentInputPhone.vue?vue&type=style&index=0&id=20c0b6b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c0b6b8",
  null
  
)

export default component.exports